<div
  class="signup-wrapper"
  [class.mobile]="isMobile()"
  [class.tablet]="isTablet()"
>
  <div class="signup-image">
    @if (isDesktop()) {
      <img
        alt="login"
        nz-image
        nzDisablePreview
        nzSrc="assets/images/login_image.jpg"
        height="100%"
      />
    } @else {
      <img
        alt="login mobile"
        nz-image
        nzDisablePreview
        nzSrc="assets/images/login_image_mobile.jpg"
        width="100%"
      />
    }
  </div>
  @if (!showForgetPassword) {
    <div class="signupForm">
      @if (isLoading()) {
        <div class="spinner-container">
          <app-spinner [black]="true"></app-spinner>
        </div>
      } @else {
        <div class="innersignup">
          <div class="header-signup">
            <img
              alt="logo"
              nz-image
              class="logo"
              nzDisablePreview
              nzSrc="assets/images/LoctitePulseLogo_red.svg"
            />
          </div>
          @if (signedUp) {
            <div class="signed-up-note body-bold">
              <div class="note-icon-wrapper">
                <!-- <i nz-icon nzType="icons:check-circle-filled" class="svg-icon multicolorIcon"></i> -->
                <span class="success-register">{{
                  i18n.langString("signed_up_success")
                }}</span>
              </div>
            </div>
          }
          @if (pwChanged) {
            <div class="signed-up-note body-bold">
              <div class="note-icon-wrapper">
                <!-- <i nz-icon nzType="icons:check-circle-filled" class="svg-icon multicolorIcon"></i> -->
                <span class="success-register">{{
                  i18n.langString("pw_changed_success")
                }}</span>
              </div>
            </div>
          }
          @if (cfg.appName === "ia") {
            <app-common-form
              [formConfigureInput]="loginFormConfig"
              [submitText]="'Enter Installation Agent'"
              (formSubmit)="login($event)"
              [isAdmin]="false"
              [captchaEnabled]="cfg.enableCaptcha"
              [formType]="'login'"
              (formChanged)="clearLoginError()"
            >
              @if (error()) {
                <p
                  class="error-login"
                  [innerHTML]="i18n.langString('login_failed')"
                ></p>
              }
              <p
                class="forgot-password"
                (click)="toForgetPassword()"
                (keyup)="toForgetPassword()"
                tabindex="0"
              >
                {{ i18n.langString("forgot_password_button") }}
              </p>
            </app-common-form>
          }
          @if (cfg.appName === "em") {
            <app-common-form
              [formConfigureInput]="loginFormConfig"
              [submitText]="'Enter Loctite Pulse'"
              (formSubmit)="login($event)"
              [isAdmin]="false"
              [formType]="'login'"
              [captchaEnabled]="cfg.enableCaptcha"
            >
              @if (error()) {
                <p
                  class="error-login"
                  [innerHTML]="i18n.langString('login_failed')"
                ></p>
              }
              <p
                class="forgot-password"
                (click)="toForgetPassword()"
                (keyup)="toForgetPassword()"
                tabindex="0"
              >
                {{ i18n.langString("forgot_password_button") }}
              </p>
            </app-common-form>
          }
          <div class="nav-container">
            @if (msalLogin) {
              <app-nav-button
                [lighttertiary]="true"
                class="signin_ms login-ms"
                (clickEvent)="loginViaMSAL()"
                svgIcon="icons:signinMS"
              >
                {{ i18n.langString("sign_in_with_microsoft") }}
              </app-nav-button>
            }
            <p
              class="no-account"
              style="margin: 16px 0px 36px 0px"
              [class.em]="cfg.appName === 'em'"
            >
              <a (click)="signupLogin()" (keyup)="signupLogin()" tabindex="0">{{
                i18n.langString("sign_up")
              }}</a>
            </p>
            @if (cfg.appName === "ia") {
              <app-nav-button
                [whiteBG]="true"
                svgIcon="icons:ai"
                class="margin-top"
                (clickEvent)="toLoctitePulseapp(EquipmentMonitorURL())"
              >
                {{ i18n.langString("go_to_em") }}
              </app-nav-button>
            }
            @if (cfg.appName === "em") {
              <app-nav-button
                [whiteBG]="true"
                svgIcon="icons:ai"
                class="margin-top em-btn"
                (clickEvent)="toLoctitePulseapp(InstallationAgentURL())"
              >
                {{ i18n.langString("go_to_ia") }}
              </app-nav-button>
            }
            <!-- @if(accBlocked()){
            <p class="error">
              {{ i18n.langString("acc_blocked") }}
            </p>
          } -->
            @if (country) {
              <div class="container">
                <button class="row">
                  <div (click)="toTermsOfUse()">
                    {{ i18n.langString("terms_of_use") }}
                  </div>
                </button>

                <button class="row">
                  <div (click)="toprivacyPolicy()">
                    {{ i18n.langString("privacy_policy") }}
                  </div>
                </button>

                <!-- <button class="row">
                    <div (click)="toCookies()">
                      {{ i18n.langString("cookies") }}
                    </div>
                  </button> -->

                <button class="row">
                  <div (click)="toCAPrivacyRights()">
                    {{ i18n.langString("CAPrivacyRights") }}
                  </div>
                </button>

                <button class="row">
                  <div (click)="toDSAR()">{{ i18n.langString("DSAR") }}</div>
                </button>
              </div>
            }
            @if (!country) {
              <div class="login-footer">
                <p
                  (click)="toLegalImprint()"
                  tabindex="0"
                  (keyup)="toLegalImprint()"
                >
                  {{ i18n.langString("imprint") }}
                </p>
                <p
                  (click)="toTermsOfUse()"
                  tabindex="0"
                  (keyup)="toTermsOfUse()"
                >
                  {{ i18n.langString("terms_of_service") }}
                </p>
                <p
                  (click)="toDataProtectionDeclaration()"
                  tabindex="0"
                  (keyup)="toDataProtectionDeclaration()"
                >
                  {{ i18n.langString("data_protection_decalaration") }}
                </p>
                <p
                  (click)="toServiceConditions()"
                  tabindex="0"
                  (keyup)="toServiceConditions()"
                >
                  {{ i18n.langString("service_conditions") }}
                </p>
                <p
                  (click)="toNoteForUsResidents()"
                  tabindex="0"
                  (keyup)="toNoteForUsResidents()"
                >
                  {{ i18n.langString("note_for_us_residents") }}
                </p>
                <p
                  (click)="toCookieConsent()"
                  tabindex="0"
                  (keyup)="toCookieConsent()"
                >
                  {{ i18n.langString("cookie_consent") }}
                </p>
                <p (click)="cookieBannerService.cookieSettings()">
                  {{ i18n.langString("cookies_settings") }}
                </p>
              </div>
            }
          </div>
        </div>
      }
    </div>
  }
  @if (showForgetPassword) {
    <div class="forgot-password-area" [class.mobile]="isMobile()">
      <app-forget-password>
        @if (cfg.appName === "ia") {
          <h1>{{ i18n.langString("app_title") }}</h1>
        }
        <div
          class="back"
          (keyup)="toLoginPage()"
          (click)="toLoginPage()"
          tabindex="0"
        >
          <nz-icon nzType="icons:arrow-left" class="svg-icon" />
          {{ i18n.langString("back_to_login") }}
        </div>
      </app-forget-password>
    </div>
  }
</div>
